// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__23O-b","name":"ConsentHeader_name__1Tk7q","birthday":"ConsentHeader_birthday__pd4BN","skeleton":"ConsentHeader_skeleton__K6c1D"};